import React from 'react';
const LeftArrowIcon = () => {
    return (React.createElement("svg", { width: "8", height: "12", viewBox: "0 0 8 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M7.70504 10.59L3.12504 6L7.70504 1.41L6.29504 0L0.295044 6L6.29504 12L7.70504 10.59Z", fill: "#696F88" })));
};
export default LeftArrowIcon;
